module.exports = __webpack_public_path__ + "static/media/21.c6d265da.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/21.png
// module id = 524
// module chunks = 0